import { IGetPayoutCommission } from 'src/store/api/payoutCommission/types';
import { createReducer } from '@reduxjs/toolkit';

import { payoutCommissionsFiltersActions } from './actions';

const initialState: IGetPayoutCommission = {
  params: {
    sort: 'id,desc',
    size: '10',
    page: '0',
  },
  data: {},
};

const payoutCommissionsFiltersReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(payoutCommissionsFiltersActions.setParams, (state, action) => ({
      ...state,
      params: action.payload,
    }))
    .addCase(payoutCommissionsFiltersActions.setBody, (state, action) => ({
      ...state,
      data: action.payload,
    }))
    .addCase(payoutCommissionsFiltersActions.clearBody, (state) => ({
      ...state,
      data: initialState.data,
    }))
    .addCase(payoutCommissionsFiltersActions.clearCurr, () => initialState),
);

export { payoutCommissionsFiltersReducer };
